"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _apolloClient = require("apollo-client");

var _apolloLinkHttp = require("apollo-link-http");

var _apolloCacheInmemory = require("apollo-cache-inmemory");

var _apolloLink = require("apollo-link");

var _utils = require("../utils");

var _apolloLinkError = require("apollo-link-error");

var _reactToastify = require("react-toastify");

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultOptions = {
  watchQuery: {
    fetchPolicy: "network-only",
    errorPolicy: "ignore"
  },
  query: {
    fetchPolicy: "network-only",
    errorPolicy: "all"
  }
};
var cache = new _apolloCacheInmemory.InMemoryCache({
  addTypename: false
});

function logout() {
  localStorage.setItem("logout-triggered", "logout" + Math.random());
  sessionStorage.clear();
  localStorage.removeItem("sessionId");
  localStorage.removeItem("jwtToken");
  var hostname = window.location.hostname.replace(/^[^.]+\./g, "");
  var port = window.location.port === "" ? "" : ":".concat(window.location.port);
  var masterUrl = "".concat(window.location.protocol, "//").concat(hostname).concat(port);
  var logoutUrl = masterUrl + "/applogout";
  if (window.location.href !== logoutUrl) window.location.href = logoutUrl;
}

var _default = function _default(uri) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  console.log("export apollo development mode file");
  var authMiddleware = new _apolloLink.ApolloLink(function (operation, forward) {
    var reqHeaders = {
      LoggerTraceId: (options.appName || "EL") + "-" + new _utils.IDGenerator().generate()
    };

    if (typeof window !== "undefined" && localStorage.getItem("jwttknkey")) {
      // add the authorization to the headers
      reqHeaders.JWTTKNCKEY = sessionStorage.getItem("jwtPersonaKey") ? sessionStorage.getItem("jwtPersonaKey") : localStorage.getItem("jwttknkey");
    } else if (typeof window !== "undefined" && localStorage.getItem("authRoleToken")) {
      reqHeaders.AuthRoleToken = localStorage.getItem("authRoleToken");
    }

    operation.setContext(function (context) {
      if (context.headers) {
        if (context.skipJwtToken && reqHeaders) {
          delete reqHeaders.JWTTKNCKEY;
        }

        return {
          headers: _objectSpread(_objectSpread({}, reqHeaders), context.headers)
        };
      }

      return {
        headers: reqHeaders
      };
    });
    return forward(operation);
  });
  var onErrorLink = (0, _apolloLinkError.onError)(function (_ref) {
    var graphQLErrors = _ref.graphQLErrors,
        networkError = _ref.networkError,
        operation = _ref.operation,
        forward = _ref.forward;

    if (graphQLErrors) {
      var _iterator = _createForOfIteratorHelper(graphQLErrors),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var err = _step.value;

          if (!Array.isArray(err) && err.message && err.message.includes("status code 401")) {
            console.log("logout in appollo client", err);
            logout();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    if (networkError) {
      var errorMessage = "Network error - ";
      errorMessage += networkError.message;

      try {
        var _operation$query, _operation$query$defi, _operation$query$defi2, _operation$query$defi3, _operation$query$defi4;

        errorMessage += ", ServiceName : " + (operation === null || operation === void 0 ? void 0 : (_operation$query = operation.query) === null || _operation$query === void 0 ? void 0 : (_operation$query$defi = _operation$query.definitions[0]) === null || _operation$query$defi === void 0 ? void 0 : (_operation$query$defi2 = _operation$query$defi.selectionSet) === null || _operation$query$defi2 === void 0 ? void 0 : (_operation$query$defi3 = _operation$query$defi2.selections[0]) === null || _operation$query$defi3 === void 0 ? void 0 : (_operation$query$defi4 = _operation$query$defi3.name) === null || _operation$query$defi4 === void 0 ? void 0 : _operation$query$defi4.value);
      } catch (_unused) {}

      _reactToastify.toast.dismiss();

      _reactToastify.toast.error(errorMessage);

      console.error("[Network error]: ".concat(errorMessage), graphQLErrors);
    }
  });

  var link = _apolloLink.ApolloLink.from([onErrorLink, new _apolloLinkHttp.HttpLink({
    uri: uri
  })]);

  return new _apolloClient.ApolloClient({
    link: (0, _apolloLink.concat)(authMiddleware, link),
    fetchOptions: {
      mode: "no-cors"
    },
    cache: cache,
    defaultOptions: defaultOptions
  });
};

exports.default = _default;